var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_4756)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.3125 45H4.6875C2.10188 45 0 42.8981 0 40.3125V4.6875C0 2.10188 2.10188 0 4.6875 0H40.3125C42.8981 0 45 2.10188 45 4.6875V40.3125C45 42.8981 42.8981 45 40.3125 45ZM4.6875 1.875C3.13687 1.875 1.875 3.13687 1.875 4.6875V40.3125C1.875 41.8631 3.13687 43.125 4.6875 43.125H40.3125C41.8631 43.125 43.125 41.8631 43.125 40.3125V4.6875C43.125 3.13687 41.8631 1.875 40.3125 1.875H4.6875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9374 35.6251C15.6862 35.6251 15.4349 35.5238 15.2512 35.3251C14.8987 34.9464 14.9193 34.352 15.2999 34.0014L27.6862 22.5001L15.2999 10.9988C14.9193 10.6482 14.8968 10.0538 15.2512 9.67509C15.6055 9.29259 16.1999 9.27384 16.5749 9.62634L29.6999 21.8138C29.8912 21.992 29.9999 22.2395 29.9999 22.5001C29.9999 22.7607 29.8912 23.0082 29.6999 23.1863L16.5749 35.3738C16.3949 35.5426 16.1662 35.6251 15.9374 35.6251Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_4756"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.b30f6d1d62c8e3920a6d23db1907daeb.svg";
export { ForwardRef as ReactComponent };